import { useMutation, useQueryClient } from "@tanstack/react-query";
import i18n from "i18n";
import UserNotification from "util/UserNotification";
import fetch from "logic/rest/FetchProvider";
import { qualifyUrl } from "util/URLUtils";
import { DATA_LAKE_API_ROUTES } from "data-lake/Constants";
const onDeleteDataLakeRetrievalOperation = ({
  streamId,
  retrievalOperationId
}) => fetch("DELETE", qualifyUrl(DATA_LAKE_API_ROUTES.DataLakeAPIController.delete(streamId, retrievalOperationId).url));
const useDataLakeRetrievalMutation = () => {
  const queryClient = useQueryClient();
  const { mutateAsync: onDeleteDataLakeRetrievalOperationMutation } = useMutation({
    mutationFn: onDeleteDataLakeRetrievalOperation,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["data-lake"]
      });
      UserNotification.success(
        i18n.t("notifications.retrieval_deleted", { ns: "enterprise_data_lake" }),
        i18n.t("notifications.retrieval_delete_title", { ns: "enterprise_data_lake" })
      );
    },
    onError: (errorThrown) => {
      UserNotification.error(
        i18n.t("notifications.retrieval_delete_failed", { ns: "enterprise_data_lake", error: errorThrown }),
        i18n.t("notifications.retrieval_delete_failed_title", { ns: "enterprise_data_lake" })
      );
    }
  });
  return {
    onDeleteDataLakeRetrievalOperationMutation
  };
};
export default useDataLakeRetrievalMutation;
